var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.properties.behavior ? _vm.properties.behavior : '',style:(_vm.imageStyle),attrs:{"draggable":"false","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }